import { canonicalUrl, documentHeadFor } from "./site";

const ensureElement = <T extends HTMLElement>(
  selector: string,
  create: () => T,
): T => {
  const found = document.head.querySelector<T>(selector);
  if (found) {
    return found;
  }
  const created = create();
  document.head.appendChild(created);
  return created;
};

/**
 * SPA 안에서 라우트가 바뀔 때 문서 head를 맞춘다. 빌드가 index.html에 넣은
 * 홈 메타와 어긋나지 않게 같은 site.ts 값을 쓴다.
 */
export const applyDocumentHead = (routeName: string): void => {
  const { title, page, noindex } = documentHeadFor(routeName);
  document.title = title;

  const canonical = document.head.querySelector('link[rel="canonical"]');
  if (page) {
    ensureElement<HTMLMetaElement>('meta[name="description"]', () => {
      const meta = document.createElement("meta");
      meta.name = "description";
      return meta;
    }).content = page.description;
    ensureElement<HTMLLinkElement>('link[rel="canonical"]', () => {
      const link = document.createElement("link");
      link.rel = "canonical";
      return link;
    }).href = canonicalUrl(page.path);
  } else {
    canonical?.remove();
  }

  // index.html already carries the indexable robots tag; a second, stricter
  // one marks unknown paths (crawlers obey the most restrictive directive).
  const noindexTag = 'meta[name="robots"][data-cs-noindex]';
  if (noindex) {
    ensureElement<HTMLMetaElement>(noindexTag, () => {
      const meta = document.createElement("meta");
      meta.name = "robots";
      meta.content = "noindex";
      meta.setAttribute("data-cs-noindex", "");
      return meta;
    });
  } else {
    document.head.querySelector(noindexTag)?.remove();
  }
};
